import { render, staticRenderFns } from "./tagging.vue?vue&type=template&id=3a8a9ec1&scoped=true"
import script from "./tagging.vue?vue&type=script&lang=js"
export * from "./tagging.vue?vue&type=script&lang=js"
import style0 from "./tagging.vue?vue&type=style&index=0&id=3a8a9ec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a9ec1",
  null
  
)

export default component.exports